/**
 * 统一的订单渠道（Channel）展示文案映射工具
 *
 * 背景：渠道的数据库存储值到前端展示文案的映射关系是写死（hardcode）在前端的，
 * 不再依赖后端接口动态获取。映射文案存放在 i18n 资源文件 common.channel 下，
 * 三语言（zh/en/th）文案值相同，因为这些是品牌专有名词，不需要翻译差异化。
 *
 * 映射关系：
 * - AXTRA_MALL -> AxtraMall
 * - AMAZE -> Amaze
 * - LOTUS -> Lotuss
 */

/**
 * channel 数据库存储值 -> i18n key 的映射
 * key 对应 i18n 资源文件中 common.channel.<code>
 */
export const CHANNEL_LABEL_KEYS = {
  AXTRA_MALL: 'common.channel.AXTRA_MALL',
  AMAZE: 'common.channel.AMAZE',
  LOTUS: 'common.channel.LOTUS',
};

/**
 * 根据 channel 数据库存储值获取前端展示文案
 * @param {(key: string) => string} t - i18next 的 t 函数
 * @param {string} code - channel 数据库存储值，如 'AXTRA_MALL'
 * @returns {string} 展示文案，未知 code 时回退返回原始 code
 */
export function getChannelLabel(t, code) {
  const i18nKey = CHANNEL_LABEL_KEYS[code];
  if (!i18nKey) {
    return code;
  }
  return t(i18nKey);
}
